export default __webpack_public_path__ + "static/back-916763ad30435a53bdf7f06dcfb689f4.png";